// React stays imported for the classic JSX transform vitest uses when this
// component renders outside the Next.js build (`verificationResend.test.tsx`).
import React from "react";
import Button from "antd/es/button";
import Flex from "antd/es/flex";

import { useLocale } from "@/lib/i18n";

import styles from "../appointmentFlow.module.css";

type VerificationResendButtonProps = {
  isCoolingDown: boolean;
  isSending: boolean;
  isSubmitting: boolean;
  onResend: () => void;
};

export default function VerificationResendButton({
  isCoolingDown,
  isSending,
  isSubmitting,
  onResend,
}: VerificationResendButtonProps) {
  const { t } = useLocale();
  const label = isCoolingDown ? t.resendCooldown : t.resend;

  return (
    <Flex justify="center" className={styles.resendRow}>
      <Button
        type="link"
        size="small"
        disabled={isSending || isSubmitting || isCoolingDown}
        onClick={onResend}
        className={styles.resendLink}
      >
        {label}
      </Button>
      <span
        className={styles.statusAnnouncement}
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {isCoolingDown ? label : ""}
      </span>
    </Flex>
  );
}
